import styles from "./Header.module.css";

function Header() {
  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <img src="/images/looogo.svg" alt="" />
      </div>
      <div className={styles.exit+' noselect'}>X</div>
    </div>
  );
}

export default Header;
